import styled from '@emotion/styled';
import TabPostCard from '@ep/modules/TabCarouselModule/TabPost/TabPostCard';
import theme from '@ep/theme';
import { Gcms_TabPost } from '@ep/types/gatsbyTypes';
import React from 'react';

export interface TabPostProps {
  tabPost: Gcms_TabPost[];
}

const Content = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  scroll-snap-align: start;
  flex-shrink: 0;
  :not(:first-of-type) {
    margin-left: 5rem;
  }

  ${theme.mediaQueries.mobileAndTablet} {
    flex-direction: column;
  }
`;

const TabPost = ({ tabPost }: TabPostProps) => {
  return (
    <Content>
      <TabPostCard tabPost={tabPost} />
    </Content>
  );
};

export default TabPost;
